import React, { useEffect } from "react";


const Register = () => {

    return (
        <div className="login-main-wrapper">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-12 p-0">
                        <div className="form-sidebar">
                            <div className="logo-section">
                                <img src="images/logo2.png" alt="logo" style={{ height: '80px' }} />
                            </div>
                            <div className="form-image d-xl-block d-lg-block d-none">
                                <img src="images/form-img.png" alt="form" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12 p-0">
                        <div className="login-main">
                            <form>
                                <h4>Register Now</h4>
                                <p className="mb-3">Register by entering the information below</p>
                                <div className="mt-2">
                                    <input type="text" className="my-width" placeholder="Name*" />
                                </div>
                                <div className="mt-2">
                                    <input type="email" className="my-width" placeholder="Email*" />
                                </div>
                                <div className="mt-2">
                                    <input type="password" className="my-width" placeholder="Password*" />
                                </div>
                                <div className="mt-2">
                                    <input type="password" className="my-width" placeholder="Confirm Password*" />
                                </div>
                                <div className="mt-2">
                                    <input type="checkbox" id="accept" className="me-2" />
                                    <label htmlFor="accept">
                                        Yes, I understand and agree{" "}
                                        <a href="#" className="text-color-pink">Terms & Conditions</a>.
                                    </label>
                                </div>
                                <a href="#" className="button-btn mt-4 text-capitalize">
                                    Register <span><i className="fas fa-angle-double-right"></i></span>
                                </a>
                                <p className="mt-2">
                                    Already have an Account. <a href="/login" className="text-color-pink">Login Now</a>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
